module.exports = __webpack_public_path__ + "static/media/trunkCurl.da1c8fe0.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/training_thumbnails/locomo/trunkCurl.png
// module id = 1708
// module chunks = 1